import React from "react";
import { Card } from "react-bootstrap";
import CtaLink from "../baseui/buttons/CtaLink";
import TemplateHome from "./TemplateHome";
import CtaLarge from "../baseui/buttons/CtaLarge";
const CardTemplateList = () => {
  return (
    <div className="card-template card-main p-0">
      <Card.Title className="d-flex mb-0">
        <h5 className="mb-0">Templates</h5>
        <div className="ms-auto">
          <CtaLink
            cta="cta cta-primary"
            to="/templates"
            state={{ isNew: true }}
            ctaText="View All"
          />
        </div>
      </Card.Title>
      <div className="card-body">
        <TemplateHome />
      </div>
      <CtaLarge
        text="Add new template"
        to="/templates"
        state={{ isNew: true }}
      />
    </div>
  );
};

export default CardTemplateList;
